import { render } from "./unreadNotification.vue?vue&type=template&id=5f357bc6"
import script from "./unreadNotification.vue?vue&type=script&lang=js"
export * from "./unreadNotification.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__